/* Si Quema cart upsell (Oct 2026): one single tub in the bag -> offer a second flavor. Automatic discount "Mix 2+ flavors: 5% off" applies at 2+ single tubs. */
(function () {
  var orig = window.SiQuemaRenderCart;
  if (!orig || window.__sqUpsell) return;
  window.__sqUpsell = true;
  var F = [["mango", "Mango"], ["watermelon", "Watermelon"], ["kiwi-strawberry", "Kiwi Strawberry"], ["cucumber-lime", "Cucumber Lime"]];
  var css = ".sq-upsell{margin:18px 0 6px;padding:18px 20px;border-radius:24px;background:rgba(217,217,217,.08);box-shadow:inset 0 0 0 1px rgba(250,250,250,.12)}" +
    ".sq-upsell__h{margin:0 0 12px;font-size:15px;line-height:1.45;color:#cdcdce}.sq-upsell__h b{color:#fafafa;font-weight:600}" +
    ".sq-upsell__row{display:flex;flex-wrap:wrap;gap:8px}.sq-upsell__b[disabled]{opacity:.6;cursor:default}";
  var st = document.createElement("style"); st.textContent = css; document.head.appendChild(st);

  function subscribed(cb) {
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cb((c.items || []).some(function (i) { return i.selling_plan_allocation; })); })
      .catch(function () { cb(true); });
  }

  function paint() {
    var C = window.SiQuemaCart, lines = document.getElementById("lines");
    var old = document.getElementById("sq-upsell"); if (old) old.parentNode.removeChild(old);
    if (!C || !lines) return;
    var items = C.all();
    var count = items.reduce(function (n, i) { return n + i.qty; }, 0);
    if (count !== 1 || !/-1$/.test(items[0].sku || "")) return;
    var have = items[0].sku.replace(/-1$/, "");
    subscribed(function (sub) {
      if (sub || document.getElementById("sq-upsell")) return;
      var box = document.createElement("div");
      box.id = "sq-upsell"; box.className = "sq-upsell";
      box.innerHTML = '<p class="sq-upsell__h"><b>Add a second flavor, get 5% off both.</b> Same price per tub as a two-pack.</p><div class="sq-upsell__row"></div>';
      var row = box.querySelector(".sq-upsell__row");
      F.filter(function (f) { return f[0] !== have; }).forEach(function (f) {
        var b = document.createElement("button");
        b.type = "button"; b.className = "btn btn--ghost sq-upsell__b"; b.textContent = "+ " + f[1];
        b.addEventListener("click", function () {
          Array.prototype.forEach.call(row.querySelectorAll("button"), function (x) { x.disabled = true; });
          b.textContent = "Adding…";
          C.add({ sku: f[0] + "-1", title: "Sí Quema " + f[1], unit: "One tub", price: 34.99,
                  poster: "siquema_" + f[0].replace(/-/g, "_") + "_1tub.jpg", qty: 1 });
        });
        row.appendChild(b);
      });
      if (lines.parentNode) lines.parentNode.insertBefore(box, lines.nextSibling);
    });
  }

  window.SiQuemaRenderCart = function () {
    orig.apply(this, arguments);
    try { paint(); } catch (e) {}
  };
  var v = document.getElementById("view-cart");
  if (v && !v.hidden) { try { paint(); } catch (e) {} }
})();
